import React, { Component } from 'react';
import { string, func } from 'prop-types';
import { translate } from 'react-i18next';

import { Button } from '@snapask/common-components';

import LineInput from '@dragonfruit/components/fields/LineInput';

import Validator from '@dragonfruit/utils/validator';

import styles from './UpdatePhoneForm.scss';

class UpdatePhoneForm extends Component {
  static propTypes = {
    countryCode: string.isRequired,
    t: func.isRequired,
    onSubmit: func.isRequired,
  };

  state = {
    error: '',
    phone: '',
  };

  validator = () => {
    const { t } = this.props;

    const validate = new Validator(this.state.phone).isEmpty(
      t('error:error.fieldEmpty')
    );

    const error = validate.getFirstErrorMessage();
    this.setState({ error });
  };

  handlePhone = value => this.setState({ phone: value });

  clickUpdatePhone = () => {
    this.props.onSubmit(this.state.phone);
  };

  render() {
    const { t, countryCode } = this.props;

    const { error, phone } = this.state;

    const isValid = !error && !!phone;

    return (
      <div>
        <div className={styles.numberField}>
          <span>{`+${countryCode}`}</span>
          <div className={styles.spacer} />
          <LineInput
            type={'number'}
            onChange={this.handlePhone}
            onBlur={this.validator}
            errorText={!!error && error}
          />
        </div>
        <Button
          type="submit"
          text={t('account.updatePhone')}
          disabled={!isValid}
          primary
          onClick={this.clickUpdatePhone}
        />
      </div>
    );
  }
}

export default translate(['account', 'error'])(UpdatePhoneForm);



// WEBPACK FOOTER //
// ./app/containers/Account/children/AccountProfile/components/AccountProfileVerify/components/UpdatePhoneForm/UpdatePhoneForm.jsx